<template>
	<vs-table class="" max-items="10" pagination :data="orders[tab.key]">
		<template slot="thead">
			<vs-th v-for="fil in field" v-if="tab.key === 'request' || fil.field !== 'actions'  "
					:style="'width:' +fil.width"
					:class="{'justify-center': fil.align && fil.align === 'center','text-center': fil.align && fil.align === 'center'}">
				{{ fil.title }}
			</vs-th>
		</template>

		<template slot-scope="{ data }">
			<vs-tr :key="indextr" v-for="(tr, indextr) in data">
				<template v-for="fil in field">
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-if="fil.field === 'name'">
						<router-link :to="'ticket/' + tr.id">
							{{ tr.name }}
						</router-link>
					</vs-td>

					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'user'">
						<!--											<router-link :to="'client/' + deepFind(tr, 'client.id')">-->
						<router-link :to="'/client/'+tr.user.user_id">
							{{ tr.user.username }}
						</router-link>
					</vs-td>

					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'author.username'">
						<router-link v-if="tr[fil.field]"
										:to="'client/' + deepFind(tr, 'author.id')">
							{{ deepFind(tr, fil.field) }}
						</router-link>
					</vs-td>

					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'status'">
						<template>
							<span
								v-if="tr.status === 5"
								class="transfer-status transfer-status_warn"
							>{{ $t('pendingConsideration') }}</span>

							<span
								v-if="tr.status === 10"
								class="transfer-status transfer-status_success"
							>{{ $t('paidOut') }}</span>

							<span v-if="tr.status === 0" class="flex items-center justify-center">
								<vs-dropdown
									v-if="tr.status_message"
									vs-custom-content
									vs-collapse
									vs-trigger-click
									:fixed="true"
									class="circle cursor-pointer flex items-center"
									icon="MoreHorizontalIcon"
								>
									<feather-icon
										icon="AlertTriangleIcon"
										class="flex items-center transfer-status_failed"
									/>

									<vs-dropdown-menu
										:fixed="true"
										class="w-48 break-words hyphens-auto finances-status-dropdown"
									>
										<div class="p-2">
											{{ tr.status_message }}
										</div>
									</vs-dropdown-menu>
								</vs-dropdown>
								<div v-else style="width: 24px; height: 24px;"></div>
								<span
									class="transfer-status transfer-status_failed ml-3"
								>{{ $t('rejected') }}</span>
							</span>
						</template>
					</vs-td>
					<template v-else-if="fil.field === 'actions'">
						<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
								v-if="tab.key === 'request' ">
							<div class="flex">
								<vs-button @click="showCancelDialog(tr)" size="small"
											color="danger" class="mr-3">{{ $t('decline') }}
								</vs-button>
								<vs-button @click="payout(tr.id, tab, indextr)" size="small" color="success">
									{{ $t('pay') }}
								</vs-button>
							</div>
						</vs-td>
					</template>


					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'chat_messages_count'">
						<span
							class="counter"
							:class="{ warn: tr.is_chat_unread }"
						>
							{{ tr.chat_messages_count }}
						</span>
					</vs-td>

					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'subject'">
						{{
							$getDeep(tr.subject, subjects)
						}}
					</vs-td>
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'work_type'">
						{{
							$getDeep(tr.work_type, works)
						}}
					</vs-td>
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'quality_level'">
						{{
							$getDeep(tr.quality_level, levels)
						}}
					</vs-td>
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="fil.field === 'task'">
						<span class="task"
								v-if="tr[fil.field]">{{ tr[fil.field].date_time | moment('DD.MM.YYYY') }}</span>
						<span class="task" @click="idOrder = tr.id;activePrompt = true"
								v-else>+</span>
					</vs-td>
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}"
							v-else-if="tr[fil.field]">
						{{ tr[fil.field] }}
					</vs-td>
					<vs-td :class="{'text-center': fil.align && fil.align === 'center'}" v-else>
						...
					</vs-td>
				</template>

			</vs-tr>
		</template>
	</vs-table>
</template>

<script>
    import databaseManager from "@/mixins/databaseManager";
    import notifier from "@/mixins/notifier";
    import OrderTableElementTable from "@/views/Tickets/OrderTableElementTable.vue";

    export default {
        name: "tableFinances",
        mixins: [databaseManager, notifier],
        props: {
            tab: { required: true },
        },
        components: {
            OrderTableElementTable,
        },
        async mounted() {
            // console.log(this.tab.key);
            try {
                const role = this.$store.state.auth.role;

                // await this.filter();
            } catch(e) {
                this.notifyError(e.message);
            }
        },
    };
</script>

<style lang="scss" scoped>

</style>